class InvziMegaTabs extends HTMLElement {
  connectedCallback() {
    this.querySelector('[role="tablist"]')?.setAttribute('aria-orientation', 'vertical');
    this.tabs = Array.from(this.querySelectorAll('[data-invzi-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-invzi-panel]'));

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('mouseenter', () => this.activate(tab.dataset.invziTab));
      tab.addEventListener('focus', () => this.activate(tab.dataset.invziTab));
      tab.addEventListener('click', () => this.activate(tab.dataset.invziTab));
      tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
    });
  }

  activate(category) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.invziTab === category;

      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.invziPanel === category;

      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });
  }

  handleKeydown(event, currentIndex) {
    if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;

    event.preventDefault();

    let nextIndex = currentIndex;

    if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;

    this.tabs[nextIndex].focus();
  }
}

if (!customElements.get('invzi-mega-tabs')) {
  customElements.define('invzi-mega-tabs', InvziMegaTabs);
}

// Keep Impact's image preloading and 500ms hover tolerance; share one immediate
// open/close state across all INVZI panels so fast switching cannot stack them.
customElements.whenDefined('mega-menu-disclosure').then(() => {
  if (customElements.get('invzi-menu-disclosure')) return;
  const NativeMegaMenu = customElements.get('mega-menu-disclosure');
  let backdrop;
  const menus = () => Array.from(document.querySelectorAll('.header__link-list .invzi-shoppable-disclosure'));
  const syncBackdrop = () => {
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'invzi-menu-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      document.body.append(backdrop);
    }
    backdrop.hidden = !menus().some(menu => menu.open);
  };
  class InvziMenuDisclosure extends NativeMegaMenu {
    connectedCallback() {
      this.summaryElement.setAttribute('aria-controls', this.contentElement.id);
      this.summaryElement.setAttribute('aria-expanded', String(this.open));
      syncBackdrop();
      if (this._invziBound) return;
      this._invziBound = true;
      this.addEventListener('keydown', event => {
        if (event.target !== this.summaryElement || event.key !== 'ArrowDown') return;
        event.preventDefault();
        this.open = true;
        this.contentElement.querySelector('[role="tab"][tabindex="0"], [role="tab"]:not([tabindex="-1"]), a[href]')?.focus();
      });
    }
    disconnectedCallback() {
      clearTimeout(this._hoverTimer);
      syncBackdrop();
    }
    _onSummaryClicked(event) {
      event.preventDefault();
      this.open = !this.open;
    }
    _transition(value) {
      clearTimeout(this._hoverTimer);
      if (value) menus().forEach(menu => { if (menu !== this) menu.open = false; });
      this.toggleAttribute('open', value);
      this.summaryElement.setAttribute('aria-expanded', String(value));
      syncBackdrop();
    }
  }
  customElements.define('invzi-menu-disclosure', InvziMenuDisclosure, {extends:'details'});
  document.addEventListener('pointerdown', event => {
    if (event.target.closest('.invzi-shoppable-disclosure')) return;
    menus().forEach(menu => { menu.open = false; });
  });
  document.addEventListener('focusout', event => {
    if (!event.relatedTarget) return;
    menus().forEach(menu => { if (!menu.contains(event.relatedTarget)) menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const active = menus().find(menu => menu.open);
    if (!active) return;
    event.preventDefault();
    active.open = false;
    active.summaryElement.focus();
  });
  window.matchMedia('(min-width: 1150px)').addEventListener('change', () => {
    menus().forEach(menu => { menu.open = false; });
  });
});
